import React, { type FC, type ReactNode, useEffect } from "react";
import notification from "@app/services/notification";
import { redirectToAuth } from "@app/router/redirectToAuth";
import { useAuthStore } from "@app/store/useAuthStore";
import { subscribeSessionLost } from "./sessionEvents";
import { TokenChecker } from "./TokenChecker";

interface SessionEventsProviderProps {
    children: ReactNode;
}

/**
 * Обрабатывает потерю сессии: очистка токена, toast, redirect на auth.
 */
export const SessionEventsProvider: FC<SessionEventsProviderProps> = ({ children }) => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

    useEffect(() => {
        return subscribeSessionLost(() => {
            useAuthStore.getState().clearSessionState();
            notification.warning("Сессия завершена. Пройдите авторизацию снова.", {
                fromId: "session-lost",
                duration: 6000,
            });
            redirectToAuth();
        });
    }, []);

    return (
        <>
            {children}
            {isAuthenticated && <TokenChecker />}
        </>
    );
};
